import intercom from '../../../../utils/intercom';

const disableTemplate = require("./disable.html.slim");
declare var angular;
declare var window;

export class TwoFactorDisable {
  static $inject = ['$rootScope', '$scope', 'users'];

  step: string;
  title: string;
  tfaMethod: string;

  state: string;
  error: string;
  errorMaxRetries: string;
  code;
  loading: string;

  constructor(
    public $rootScope,
    public $scope,
    private users
  ) {
    $rootScope.$on('disableTwoFactor', ((event, data) => {
      this.title = 'Disable Two-step';
      this.step = 'start';
      this.tfaMethod = data.tfaMethod;
      this.loading = '';
      this.errorMaxRetries = '';
      this.$scope.twoFactorDisableDialog.show();
    }));
  }

  disableTwoFactor() {
    this.next('confirm');
  }

  confirmCode(code) {
    this.state = "submitting";
    this.users.confirmTwoFactorAuth(code, false)
      .then(() => {
        this.code = null;
        this.state = '';
        this.users.disableTwoFactorAuth()
          .then(() => {
            this.$scope.twoFactorDisableDialog.hide();
            this.$rootScope.$emit("update_tfa_dashboard");
          });
      })
      .catch((error) => {
        this.code = null;
        this.state = 'error';
        this.error = error.data.message;
      });
  }

  requestCode() {
    if(this.errorMaxRetries === '') {
      this.loading = 'loading';
      this.users.requestTwoFactorAuth()
        .then((resp) => {
          if(this.step !== 'confirm') {
            this.next('confirm');
          }
          this.loading = "loaded";
          this.state = '';
          this.error = null;
        })
        .catch((error) => {
          this.loading = "";
          if (error.data.error_code && error.data.error_code === 'max_retries_reached') {
            this.errorMaxRetries = error.data.message;
            this.resetSendError();
          }else{
            this.state = 'error';
            this.error = error.data.message;
          }
        });
    }
  }

  resetSendError() {
    setTimeout(() => { 
      this.errorMaxRetries = '';
    }, 120000);
  }

  next(step) {
    this.state = 'start';
    this.step = step;
    if(this.step === 'confirm' && this.tfaMethod === 'sms') {
      this.requestCode();
    }
  }

  back(step) {
    this.state = 'start';
    this.step = step;
  }

  openIntercomMessage() {
    this.$scope.twoFactorEnableDialog.cancel();
    intercom.show('showNewMessage');
  }
}

angular.module("wbComponents").directive("twoFactorAuthDisable", function() {
  return {
    restrict: 'E',
    templateUrl: disableTemplate,
    controller: TwoFactorDisable,
    controllerAs: 'disable',
    bindToController: true
  };
});
